import React, { useContext, useEffect } from "react";
import * as IconlyPack from "react-iconly";
import { useHistory } from "react-router";
import Header from '../../../../Navs/Header';
import GestionSoinsAdminTable from "../../../../Tables/Assurance/GestionSoinsAdminTable/GestionSoinsAdminTable";
import NavbarVerticalV2 from "../../../navbarVerticalV2/navbarVerticalV2";
import GenererFicheSoinAdmin from "./GenererFicheSoinAdmin";

var ActiviteSoinAssureur = () => {
 

  return (
    <div className="dashboard-item-container">
      <div className="container-fluid body-background-dashboard">
        <Header />

        <div className="row">
          {/* Navbar Desktop  */}
          <div className="nav-container">
            <NavbarVerticalV2  />
          </div>

          <div className="offset-xl-1 offset-lg-1 col-xl-11 col-lg-11 col-md-12 content-position-after-header px-md-3 px-0 soinsy">
            <div className="page-body-container">
              <div className="page-content-container">
                <div className="page-first-row-container">
                  <div className="page-title-container">
                    <h1 className="page-title">
                    Activités de soins
                    </h1>
                  </div>
                  <div
                    className="adding-item-container linkable"
                    data-toggle="modal"
                    data-target="#GenererFicheSoinAdmin"
                  >
                    <span className="icon-container">
                      <IconlyPack.Plus set="light" primaryColor="gray" />
                    </span>
                    <span className="adding-item-label">
                    Générer une fiche de soins
                    </span>
                  </div>
                </div>
                <div className="parent-table-container">
                  <GestionSoinsAdminTable
                  />
                </div>
                <div
                  className="modal fade easypm-modal add-soin-modal"
                  id="GenererFicheSoinAdmin"
                  tabIndex="-1"
                  aria-labelledby="GenererFicheSoinAdminLabel"
                  data-backdrop="static"
                  aria-hidden="true"
                >
                  <GenererFicheSoinAdmin />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiviteSoinAssureur;
